import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {RoleGuard} from '@services/role.guard';
import {SearchResultGuard} from "@modules/consignment/services/search-result.guard";
import {OrderSummaryGuard} from "@modules/consignment/services/order-summary.guard";
import {OrderCompleteGuard} from "@modules/consignment/services/order-complete.guard";
import {ConsignmentComponent} from './consignment.component';
import {SearchComponent} from "@modules/consignment/search/search.component";
import {SearchResultsComponent} from "@modules/consignment/search-results/search-results.component";
import {OrderCompleteComponent} from "@modules/consignment/order-complete/order-complete.component";
import {OrderSummaryComponent} from "@modules/consignment/order-summary/order-summary.component";

const route: Routes = [
  {
    path: 'create-consignment',
    component: ConsignmentComponent,
    canActivate: [RoleGuard],
    data: {expectedRole: '2'},
    children: [
      {
        path: '',
        component: SearchComponent
      },
      {
        path: 'search-result',
        component: SearchResultsComponent,
        canActivate: [SearchResultGuard],
      },
      {
        path: 'order-summary',
        component: OrderSummaryComponent,
        canActivate: [OrderSummaryGuard]
      },
      {
        path: 'order-complete',
        component: OrderCompleteComponent,
        canActivate: [OrderCompleteGuard]
      },
    ]
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(route)
  ],
  exports: [
    RouterModule
  ]
})

export class ConsignmentRoutingModule {
}



// WEBPACK FOOTER //
// ./src/app/modules/consignment/consignment-routing.module.ts